import { render, staticRenderFns } from "./SingleReturn.vue?vue&type=template&id=5f9d905b&scoped=true&"
import script from "./SingleReturn.vue?vue&type=script&lang=js&"
export * from "./SingleReturn.vue?vue&type=script&lang=js&"
import style0 from "./SingleReturn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleReturn.vue?vue&type=style&index=1&id=5f9d905b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d905b",
  null
  
)

component.options.__file = "SingleReturn.vue"
export default component.exports